// libraries
import React from "react";
import PropTypes from "prop-types";
import { SortableContainer } from "react-sortable-hoc";

// components
import SortableStageItem from "../SortableStage";

const RenderStage = SortableContainer(
	({
		stages,
		setStages,
		updateStageName,
		updateOption,
		isRemove,
		addOptionToStage,
		errors,
		images,
		setImages,
		updateStageImage,
		manualSortStage,
		modalOption,
		actionsList,
		warningMinutes,
		timeoutMinutes,
	}) => {
		return (
			<div>
				{stages.map((stage, index) => {
					return (
						<SortableStageItem
							key={`stage-${stage.id}`}
							index={index}
							position={index}
							stage={stage}
							stages={stages}
							setStages={setStages}
							updateOption={updateOption}
							isRemove={isRemove}
							updateStageName={updateStageName}
							addOptionToStage={addOptionToStage}
							errors={errors}
							images={images}
							setImages={setImages}
							updateStageImage={updateStageImage}
							manualSortStage={manualSortStage}
							modalOption={modalOption}
							actionsList={actionsList}
							warningMinutes={Number(warningMinutes) || 0}
							timeoutMinutes={Number(timeoutMinutes) || 0}
						/>
					);
				})}
			</div>
		);
	}
);

// PropTypes
RenderStage.propTypes = {
	stages: PropTypes.array.isRequired,
	setStages: PropTypes.func.isRequired,
	updateStageName: PropTypes.func.isRequired,
	addOptionToStage: PropTypes.func.isRequired,
	updateOption: PropTypes.func.isRequired,
	isRemove: PropTypes.func.isRequired,
	errors: PropTypes.object,
	images: PropTypes.array,
	setImages: PropTypes.func,
	updateStageImage: PropTypes.func,
	manualSortStage: PropTypes.func.isRequired,
	modalOption: PropTypes.string,
	actionsList: PropTypes.object,
	warningMinutes: PropTypes.number,
	timeoutMinutes: PropTypes.number,
};

export default RenderStage;
